import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<Response, any>({
    query: (id) => ({
      url: `v4/pitch-owner/tournaments/${id}/remove-image`,
      method: 'DELETE',
    }),
  });

interface Response {
  data: {
    message: string;
    code: number;
  };
}
